import { Container } from 'reactstrap';
import MiAccordion from '../MiAccordion';
import React, { useState, memo, useRef, useEffect } from 'react';
import { Paper } from '@material-ui/core';
import ProductView from './ProductView';
import ProductHeader from './ProductHeader';
import DescriptionAndKey from './DescriptionAndKey';
import Typography from '@material-ui/core/Typography';
import SchoolDetail from './SchoolDetail';
import CrimeDetail from './CrimeDetail';
import AmenityDetail from './AmenityDetail';
import DemographicDetail from './DemographicDetail';
import AreaSummary from './AreaSummary';

const Neighbourhood = ({ data }) => {

    const [accordionContent, setAccordionContent] = useState([]);

    useEffect(() => {

        let aContent = [
            { heading: "Key Details", content: (<DescriptionAndKey data={data} />) },
            { heading: "Description", content: (<Typography variant="body2" gutterBottom dangerouslySetInnerHTML={{ __html: data.text }} />) },
            /*{ heading: "Info", content: (<Typography variant="body2">{data.bedrooms}</Typography>) },*/
            
        ];

        setAccordionContent(aContent)

    }, [data]);

    return (
        <Paper>
            <Typography variant="h6" gutterBottom>Area Summary</Typography>
            <AreaSummary data={data} />
            <br/>
            <Typography variant="h6" gutterBottom>Schools</Typography>
            <SchoolDetail data={data}/>
            <br />
            <Typography variant="h6" gutterBottom>Crime</Typography>
            <CrimeDetail data={data} />
            <br />
            <Typography variant="h6" gutterBottom>Amenities</Typography>
            <AmenityDetail data={data}/>
            <br />
            <Typography variant="h6" gutterBottom>Demographics</Typography>
            <DemographicDetail />
            <br />
        </Paper>
    );
}


export default memo(Neighbourhood);